import { render, staticRenderFns } from "./wuliuInfo.vue?vue&type=template&id=25d28684&scoped=true&"
import script from "./wuliuInfo.vue?vue&type=script&lang=js&"
export * from "./wuliuInfo.vue?vue&type=script&lang=js&"
import style0 from "./wuliuInfo.vue?vue&type=style&index=0&id=25d28684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d28684",
  null
  
)

export default component.exports